import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { jsonParse, jsonToQueryString } from 'src/app/app.component';
import { SessionService } from '../session/session.service';
import { Router } from '@angular/router';
import { catchError, map } from 'rxjs/operators';
import { Observable, BehaviorSubject, of } from 'rxjs';
import { getIP } from 'src/app/modules/jobseeker-registration/services/registration/jobseeker-registration.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {


  api_url = environment.SERVER_URL + "Referral/";
  login_url = environment.SERVER_URL + 'icr/';
  refresh_token_flag = 0;
  file_url = environment.SERVER_URL + 'Parsing/';
  first_login_details;
  //login_url: string = "http://192.168.0.147:9899/api/";
  constructor(
    private http: HttpClient,
    private session: SessionService,
    private router: Router
  ) { }

  generateAccessToken(request) {
    //params['Primary-Role'] = 'recruiter';
    return this.http.post(this.login_url + 'weblogin', request).pipe(map(res => {

      if (res && res['status'] && res['data'].userDetails) {
        this.session.setUserDetails(res['data'].userDetails);
      }
      return res;
    }));
  }

  generateNewAccessToken() {
    return new Observable((obs) => {
      try {
        if (!this.refresh_token_flag) {
          this.refresh_token_flag = 1;
          let params = this.session.getSession();
          let obj = {
            grant_type: 'refresh_token',
            username: params['userName'],
            client_id: 't@ll!nt',
            client_secret: 't@ll!nt',
            refresh_token: params['refresh_token'],
            'Primary-Role': 'careers',
          };
          let query_string = jsonToQueryString(obj);
          this.http.post(this.login_url + 'token', query_string, { headers: { "Content-Type": "application/x-www-form-urlencoded" } }).subscribe(res => {
            this.session.setSession(res);
            this.refresh_token_flag = 0;
            obs.next(true);
          }, err => {
            obs.next(false);
            this.router.navigate(['/login']);
          });
        }
        else {
          obs.next(false);
        }
      }
      catch (err) {
        obs.next(false);
      }
    })
  }

  getSocialMediaDetails() {
    return this.http.get(this.api_url + 'PortalsData', { params: { lng_id: '1' } });
  }

  loginTwitter(api) {
    return this.http.get(api);
  }
  forgotPassword(userId: string) { //method for sending email via user ID
    return this.http.post(this.login_url + "UserPassword/ForgotPassword?lng_id=1", {
      "user_name": userId,
      "user_role": 'careers'
    },
      {
        observe: 'body'
      })
  }
  getISD() {
    return this.http.get(this.login_url + 'ISD', { params: { lng_id: '1' } });
  }
  signUp(details) {
    return this.http.post(this.login_url + 'SignUp', details).pipe(map(res => {
      this.session.setSession(res['data']);

      return res;
    }));
  }
  oauthLoginV1(api) {
    return this.http.post(api, {});
  }
  saveFile(file) {
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    return this.http.post(this.file_url + 'XMLToJSON', file, { headers: undefined });

  }
  logout() {
    return this.http.get(this.login_url + 'UserPassword/UserLogout');
  }
  getFormDetails(params) {
    return this.http.get(this.login_url + "DynamicTemplates/FormPlot", {
      params: params
    })
    // return this.HttpService.get('assets/sample/data.json')
  }

  firstLogin(params?) {
    let obj = {
      sellerShortCode: environment.SHORTCODE
    }
    return this.http.post(environment.SERVER_URL + 'icrweb/home/get_myjourney_status_check', obj, {
      params: params
    }).pipe(map(res => {
      console.log(res);
      if (res && res['status'] && res['data'].myJourney) {
        this.session.setMyJourneyDetails(res['data']);
      }
      return res;
    }));
  }
  updateFirstLoginDetails() {
    this.first_login_details = jsonParse(sessionStorage.getItem('o'))
    return this.first_login_details
  }
  getFormMaster(params) {
    return this.http.get(this.login_url + "DynamicTemplates/FormPlotMasters", {
      params: params
    });
  }
  getip() {
    let basic_details: BehaviorSubject<any> = new BehaviorSubject(null);
    let item = localStorage.getItem('getipobject')
    if (item) {
      item = jsonParse(item);
      basic_details.next(item)
      return basic_details.asObservable();
    }
    else {
      return this.http.get('https://ipinfo.io/?token=f411bffc738445').pipe(
        catchError((error) => {
          console.error('An error occurred:', error);
          // You can return a default value here, for example:
          return of({
            "ip": "1.1.1.1",
            "city": "Default",
            "region": "Default",
            "country": "IN",
            "loc": "26.4521,74.6387",
            "org": "AS45609 Bharti Airtel Ltd. AS for GPRS Service",
            "postal": "305001",
            "timezone": "Asia/Kolkata"
          });
        })
      );
    }
  }
  getMasters(params?) {
    if (!params) {
      try {
        let ip_details = getIP()
        params = {}
        params['ip'] = ip_details['ip'];
        params['sellerShortCode'] = environment.SHORTCODE;
      }
      catch (err) {

      }
    }
    else {
      params['sellerShortCode'] = environment.SHORTCODE;
    }
    return this.http.get(environment.SERVER_URL + 'icrweb/countryMaster', { params: params, headers: { header_type: '2' } })
  }
  getAllLabels(file_path) {
    return this.http.get('assets/i18/' + file_path + '.json');
  }
  checkLogin(request) {
    return this.http.post(environment.SERVER_URL + 'icr/login_check', request)
  }
}
